"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var constants_1 = require("./constants");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
exports.focusedRow = reselect_1.createSelector(moduleState, function (state) { return state === null || state === void 0 ? void 0 : state.focusedRow; });
exports.focusedElement = reselect_1.createSelector(moduleState, function (state) { return state === null || state === void 0 ? void 0 : state.focusedElement; });
exports.isFocused = reselect_1.createSelector(moduleState, function (state) { return state === null || state === void 0 ? void 0 : state.isFocused; });
exports.focusedState = reselect_1.createSelector(moduleState, function (state) { return state; });
//# sourceMappingURL=selectors.js.map